import ContextMenu from "./ContextMenu";

export default ContextMenu;
